export default [
  'components-promo-title',
]
